export default __webpack_public_path__ + "static/media/icon-recurring.94c02194.svg";